<template>
    <div class="container container-main-noticies">
        <div class="row row__primary-block">
            <div class="col-12 col-md-9"> 
                <Carousel v-if="slider && slider.length" :slider="slider" width="832" height="456" />
            </div>

            <div class="col-12 col-md-3">
                <Tabs>
                    <SuperLink 
                        class="noticies-item noticies-item__tab" 
                        :href="simple.link" 
                        target="_self" 
                        v-if="simple.link">
                        <div class="noticies-item--image">
                            <img v-if="simple.image" :src="utils.image(simple.image,width=256,height=136)" alt="">
                            <img v-else-if="simple.link.image" :src="utils.image(simple.link.image,width=256,height=136)" alt="">
                        </div>
                        <p class="noticies__label">
                            <strong v-if="simple.hat">{{simple.hat}}</strong>
                            <strong v-else-if="simple.link && simple.link.editorial">{{simple.link.editorial.title}}</strong>
                        </p>
                        <p class="noticies__title noticies__title--blue"><strong>{{simple.title}}</strong></p>
                    </SuperLink>
                </Tabs>
            </div>
        </div>

        <div class="row row__secondary-block row__secondary-block--variation-3" v-if="small">
            <div class="col-12 col-md-4 col-lg-2" v-for="sm in small" :key="sm.id">
                <SmallItem :item="sm" />
            </div>
        </div>
    </div>
</template>

<script>
import utils from '@/utils'
import Carousel from '@/components/home/header/Carousel'
import SmallItem from '@/components/home/header/Small'
import Tabs from '@/components/home/header/Tabs'
import SuperLink from '@/components/SuperLink'

export default {
    name: 'Header01',
    components: {Carousel, SmallItem, Tabs, SuperLink},
    props:['slider', 'main', 'simple', 'small'],
    data: function (){
        return {
            utils: utils
        }
    },
}
</script>